import React, { useRef, useState } from 'react';
import AppModal from '../../components/UI/Modal';
import { orderError } from '../../actions/api/order';

let nextFormId = 0;
export default function OrderDialog({ title, children, onClose, onSubmit, submitText = 'Сохранить', disabled = false, busy = false, danger = false, size = 'lg', className = '', hasChanges = false }) {
  const [formId] = useState(() => `order-dialog-form-${++nextFormId}`);
  const [saving, setSaving] = useState(false);
  const savingRef = useRef(false);
  const [error, setError] = useState('');
  const [dirty, setDirty] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const locked = saving || busy;
  const close = () => {
    if (savingRef.current || busy) return;
    if ((dirty || hasChanges) && onSubmit) setConfirmClose(true);
    else onClose();
  };
  const submit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (savingRef.current || busy || disabled || !onSubmit) return;
    savingRef.current = true;
    setSaving(true); setError('');
    try { await onSubmit(); onClose(); }
    catch (cause) { setError(orderError(cause)); }
    finally { savingRef.current = false; setSaving(false); }
  };
  return <AppModal show handleClose={close} size={size}
    className={`orders-modal ${className}`} backdropClassName="orders-modal-backdrop"
    preventOutsideClose keyboard={!locked} closeButton={false}
    titleId={`${formId}-title`}
    modalTitle={<div className="orders-card-modal__title"><span>{title}</span><button type="button" className="orders-close" disabled={locked} onClick={close} aria-label="Закрыть">×</button></div>}
    footer={confirmClose ? <><span>Закрыть без сохранения?</span><button type="button" className="orders-btn" disabled={locked} onClick={() => setConfirmClose(false)}>Продолжить редактирование</button><button type="button" className="orders-btn orders-btn--quiet-danger" disabled={locked} onClick={() => { if (!savingRef.current && !busy) onClose(); }}>Закрыть без сохранения</button></> : <><button type="button" className="orders-btn" disabled={locked} onClick={close}>Закрыть</button>{onSubmit && <button type="submit" form={formId} className={`orders-btn orders-btn--${danger ? 'danger' : 'primary'}`} disabled={locked || disabled}>{locked ? 'Сохраняется…' : submitText}</button>}</>}
  >
    <form id={formId} onSubmit={submit} onChange={() => { setDirty(true); setError(''); }}>
      <fieldset className="orders-dialog-fields" disabled={locked}>{children}</fieldset>
      {error && <div className="orders-message orders-message--danger" role="alert">{error}</div>}
    </form>
  </AppModal>;
}
